import React, { Component, PropTypes } from 'react'
import CSSModules from 'react-css-modules'
import styles from './Price.css'
import FormActions from '../../actions/FormActions'

import { Select } from '../index'

@CSSModules(styles, { allowMultiple: true })
export default class Price extends Component {
  static propTypes = {
    disabled : PropTypes.bool,
    fixedPrice: PropTypes.string,
    selectedPriceType: PropTypes.string
  }
  static defaultProps = {
    fixedPrice: '-'
  }
  _onRadioButtonPressed (name) {
    FormActions.selectPriceType(name)
  }

  render () {
    return (
      <div styleName="price-container">
        <span styleName={this.props.disabled ? 'has-error error' : 'no-error'}><div />{this.props.disabled ? 'Destination krävs' : ''}</span>
        <div styleName="col">
          <label>
          Taxameter
          </label>
          <Select
            checked={this.props.selectedPriceType === 'taxameter'}
            name="priceType"
            onClick={this._onRadioButtonPressed.bind(this, 'taxameter')}
            type="radio" />
        </div>
        <div styleName="col">
          <label>
          Fast pris <strong>{this.props.fixedPrice} kr</strong>
          </label>
          <Select
            checked={this.props.selectedPriceType === 'fixedPrice'}
            disabled={this.props.disabled}
            name="priceType"
            onClick={this._onRadioButtonPressed.bind(this, 'fixedPrice')}
            type="radio" />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/Price/Price.js